"use strict";

let $almaWidget = $("#alma-pdp-widget");
let $body = $("body");
let widgets = {};

/**
* Initializes the Alma widget on the page if the Alma object and the widget element are available.
* This function checks if the Alma object is defined and if the widget element exists on the page.
* If both conditions are met, it initializes the Alma widget with the merchant data and API mode
* (live or test) and then sets up the widget.
*/
function initializeAlmaWidget() {
    if (typeof Alma === "undefined" || $almaWidget.length === 0) {
        return;
    }

    widgets = Alma.Widgets.initialize(
        $almaWidget.attr("data-merchant"),
        $almaWidget.attr("data-live") ? Alma.ApiMode.LIVE : Alma.ApiMode.TEST
    );

    setupAlmaWidget();
}

/**
* Sets up the Alma payment plans widget on the product detail page.
* 
* This function retrieves product and cart amounts, parses available payment plans,
* filters the plans based on the product amount, and initializes the Alma widget 
* with the appropriate configuration.
* 
* @returns {void}
*/
function setupAlmaWidget() {
    let productAmount = Math.ceil($almaWidget.attr("data-product-amount"));
    let cartTotal = Math.ceil($almaWidget.attr("data-cart-total"));
    let plans = JSON.parse($almaWidget.attr("data-plans")) || [];
    let availableProductPlans = [];

    availableProductPlans = plans.filter(function (plan) {
        return plan.minAmount <= productAmount && plan.maxAmount >= productAmount;
    });

    widgets.add(Alma.Widgets.PaymentPlans, {
        container: "#alma-pdp-widget",
        purchaseAmount: availableProductPlans.length ? productAmount : cartTotal + productAmount,
        locale: $almaWidget.data("locale"),
        hideIfNotEligible: true,
        plans: plans
    });
}

/**
* Updates Alma widget values based on various product and cart events.
* 
* This function sets up event listeners on the body element to update the Alma widget's 
* data attributes when certain events are triggered, such as after a product attribute 
* selection or after adding a product to the cart. It ensures that the Alma widget's 
* displayed values are kept in sync with the current product price and cart total.
* 
* Listens to:
* - "product:afterAttributeSelect": Triggered after a product attribute is selected.
* - "cart:basketTotalUpdate": Triggered after the cart's total is updated.
* - "product:afterAddToCart": Triggered after a product is added to the cart.
* 
* @fires product:afterAttributeSelect
* @fires cart:basketTotalUpdate
* @fires product:afterAddToCart
*/
function updateValuesOnEvents() {
    $body.on("product:afterAttributeSelect", function (e, response) {
        if (typeof Alma === "undefined" || $almaWidget.length === 0) {
            return;
        }

        if (response.data.product.price.sales && response.data.product.price.sales.value) {
            $almaWidget.attr("data-product-amount", response.data.product.price.sales.value * 100);
            setupAlmaWidget();
        }
    });


    $body.on("cart:basketTotalUpdate product:afterAddToCart", function (e, response) {
        if (typeof Alma === "undefined" || $almaWidget.length === 0 || response.almaWidgetCartTotal === "undefined") {
            return;
        }

        $almaWidget.attr("data-cart-total", response.almaWidgetCartTotal * 100);
        setupAlmaWidget();
    });
}

module.exports = {
    initializeAlmaWidget: initializeAlmaWidget,
    updateValuesOnEvents: updateValuesOnEvents
};
